<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="getSafeDisplayDate(issueDateEntity.editedValue || issueDateEntity.initialValue)"
  />
</div>
